import pic from '@/utils/pic'
const {
  icon1,
  icon2,
  icon3,
  langzh,
  langen,langno,
  langtw,
  langjp,
  langxby,
  langit,
  langdy,
  langfy,
  langhy,
  langty,
  langyn,
  zhsz,
  jtrz,
  sfrz,
  iconchecked,
  iconcheck,
  icon1_01,
  icon1_02,
  icon1_03,
  icon1_04,
  banner01,
  banner02,
  banner03
} = pic

export default {
  "currency": {
    "bb": "Scambio di criptovalute",
    "bba": "Conto di criptovalute",
    "hy": "Scambio di contratti",
    "jg": "Contratti a termine",
    "hya": "Conto di contratti"
  },
  "index": {
    "h24": "Volume 24H",
    "header_title": ["Per il trading di asset digitali, scegli " + window.GLOBAL.LANG_TITLE.it],
    "header_small_title": "La soluzione completa per il trading di asset digitali su blockchain",
    "header_msg": "Sicuro - Stabile - Affidabile",
    "register_title": "Registrati per un account globale " + window.GLOBAL.LANG_TITLE.it + " e inizia il tuo viaggio di trading",
    "register_pl": "Inserisci la tua email o numero di telefono",
    "register": "Registrati",
    "featureTitleWhy": "Perché scegliere noi",
    "featureTitle": "Sicuro · Stabile · Affidabile",
    "featureMsg": "",
    "featureList": [
      {
        "icon": "icon1",
        "title": "Tecnologia del portafoglio sicura",
        "msg": [
          "Tecnologia di portafogli freddi e caldi sviluppata da un team di sicurezza di livello mondiale, mai verificati eventi di perdita di fondi.",
          ""
        ]
      },
      {
        "icon": "icon2",
        "title": "Ampia gamma di servizi di asset crittografici",
        "msg": [
          "Supporta il trading di spot e vari derivati, è il tuo custode personale per entrare nel mondo degli asset crittografici.",
          ""
        ]
      },
      {
        "icon": "icon3",
        "title": "Clienti in tutto il mondo",
        "msg": [
          "Offriamo servizi completi di asset crittografici a utenti in oltre 130 paesi o regioni.",
          ""
        ]
      }
    ],
    "bannerList": [
      {
        "icon": "banner01",
        "title": "Impegnati a fornire sicurezza e stabilità leader del settore",
        "msg": [
          "I contratti intelligenti garantiscono la sicurezza degli asset degli investitori",
          "Le performance di trading sono reali",
          "Servizio garantito 24h"
        ]
      },
      {
        "icon": "banner02",
        "title": "Voglio comprare e vendere immediatamente con operazioni semplici",
        "msg": [
          "Interfaccia di trading semplice",
          "Si riflette immediatamente nel saldo del tuo account",
          "La maggior parte delle criptovalute può essere scambiata"
        ]
      },
      {
        "icon": "banner03",
        "title": "Voglio guadagnare attivamente tramite il trading di contratti a termine",
        "msg": [
          "Disponibile al momento dell'apertura del conto",
          "Strategie di investimento per trading di futures",
          "Trading disponibile 365 giorni all'anno, 24 ore su 24, anche nei fine settimana"
        ]
      }
    ],
    "featureList2": [
      {
        "icon": "icon1_01",
        "title": "Trasparente e aperto",
        "msg": [
          "Utilizzando le caratteristiche della blockchain e dei contratti intelligenti, registriamo le performance di trading sulla blockchain e garantiamo la sicurezza degli asset degli investitori tramite contratti intelligenti",
          ""
        ]
      },
      {
        "icon": "icon1_02",
        "title": "Investimenti intelligenti",
        "msg": [
          "Diversificati strategie fornite dai migliori esperti di trading quantitativo, a tua scelta",
          ""
        ]
      },
      {
        "icon": "icon1_03",
        "title": "Classificazione del rischio",
        "msg": [
          "Progettato per diversificare i prodotti di investimento in base alle diverse preferenze di rischio e gestione degli asset degli investitori, eliminando efficacemente le barriere all'ingresso",
          ""
        ]
      },
      {
        "icon": "icon1_04",
        "title": "Prodotti diversificati",
        "msg": [
          "Offriamo meccanismi di piattaforma flessibili per soddisfare le esigenze di investimento di vari utenti, continuando a produrre servizi finanziari innovativi superiori al mercato",
          ""
        ]
      }
    ],
    "featureTitle2": "Trading multi-piattaforma ovunque e in qualsiasi momento",
    "featureMsg2": "Copertura su più piattaforme iOS e Android, supporto per tutte le funzionalità aziendali",
    "tab": ["Criptovalute principali", "Classifica 24H"],
    "thead": ["Nome", "Prezzo attuale", "Prezzo massimo del giorno", "Prezzo minimo del giorno", "Classifica di crescita", "Volume 24H", "Operazioni"],
    "more": "Visualizza di più >",
    "btn": "Trading",
    "dealsTitle": "Servizi di trading one-stop",
    "dealsTab": [
      {
        "title": "Scambio di criptovalute",
        "content": "Lo scambio di criptovalute è per il cambio tra asset digitali, utilizzando USDT come unità di prezzo per acquistare altre valute. " + window.GLOBAL.LANG_TITLE.it +
          "Lo scambio di criptovalute supporta il trading in tempo reale di Bitcoin, Ethereum, Litecoin e altri asset digitali.",
        "src": "/static/image/deals-1.jpg",
        "path": ""
      },
      {
        "title": "Trading di contratti",
        "content": "Un derivato finanziario delle criptovalute, che supporta la scelta di andare long o short sui contratti per guadagnare profitti, ed è semplice da usare, senza scadenza. " + window.GLOBAL.LANG_TITLE.it +
          "I contratti hanno un sistema di gestione del rischio avanzato, con leva fino a 100 volte.",
        "src": "/static/image/deals-2.jpg",
        "path": ""
      }
    ]
  },
  "market": {
    "tab": ["Preferiti", "Contratti", "Scambio di criptovalute"],
    "thead": ["Valuta", "Prezzo attuale", "Variazione 24H", "Minimo 24H", "Massimo 24H", "Volume 24H", "Operazioni"],
    "nodata": "Nessun dato disponibile"
  },
  "footer": {
    "p": "©Copyright " + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.it + ". Tutti i diritti riservati.",
    "dd": [
      {
        "dt": "Chi siamo",
        "dd": [
          {
            "title": "Informazioni sull'azienda",
            "id": 1
          },
          {
            "title": "Centro assistenza",
            "type": "help"
          }
        ]
      },
      {
        "dt": "Supporto utenti",
        "dd": [
          {
            "title": "Accordo utente",
            "id": 3
          },
          {
            "title": "Termini sulla privacy",
            "id": 5
          }
        ]
      },
      {
        "dt": "Contattaci",
        "icon": true
      }
    ]
  },
  "nav": {
    "btn": ["Accedi", "Registrati", "Gestione asset", "Scarica APP"],
    "nav": [
      {
        "title": "Home",
        "path": "/index",
        "name": "index"
      },
      {
        "title": "Mercato",
        "path": "/market",
        "name": "market"
      },
      {
        "title": "Contratti a termine",
        "path": "/deal_jg",
        "name": "deal_jg"
      },
      {
        "title": "Rimborso posizioni",
        "path": "/profit_index",
        "name": "profit_index"
      }
    ],
    "nav2": [
      {
        "title": "I miei asset",
        "path": "/asset"
      }
    ],
    "menus": [
      {
        "icon": langzh,
        "title": "Centro utenti",
        "path": "/setting"
      },
      {
        "icon": langen,
        "title": "Disconnettersi"
      },
    ],
  lang: [{
      icon: langen,
      lang: "English",
      key: 'en'
    },
    {
      icon: langno,
      lang: "Norsk",
      key: 'no'
    },
    {
      "icon": langit,
      "lang": "Italiano",
      "key": "it"
    },
    {
      icon: langxby,
      lang: "España",
      key: 'es'
    },
    {
      icon: langfy,
      lang: "français",
      key: 'fr'
    },
    {
      icon: langdy,
      lang: "Deutsche",
      key: 'de'
    },
    {
      icon: langjp,
      lang: "日本語",
      key: 'jp'
    },
    {
      icon: langhy,
      lang: "한국어",
      key: 'kr'
    },
    {
      icon: langty,
      lang: "ไทย",
      key: 'th'
    },
    {
      icon: langyn,
      lang: "Tiếng Việt",
      key: 'vn'
    },
    {
      icon: langzh,
      lang: "简体中文",
      key: 'zh'
    },
    {
      icon: langtw,
      lang: "繁體中文",
      key: 'tw'
    },
  ]
  },
  "download": {
    "xz": "Scarica"
  },
  "login": {
    "login": "Benvenuto nel login",
    "msg": "Inserisci il tuo account registrato",
    "list": ["Telefono/email", "Password", "Password dimenticata?", "Accedi", "Non hai un account? Registrati ora"],
    "message": "L'account o la password non possono essere vuoti"
  },
  "register": {
    "dl": ["Registrazione tramite telefono", "Registrazione tramite email"],
    "title": "Registrazione account",
    "country": "Nazionalità",
    "country_info": "Le informazioni sulla nazionalità non possono essere modificate dopo la registrazione, assicurati di scegliere correttamente",
    "account": "Account",
    "code_text": "Inserisci il codice di verifica",
    "code_btn": "Ottieni codice di verifica",
    "code_unit": "s",
    "code_no_data": "Il codice di verifica non può essere vuoto",
    "password_text": "Inserisci la password",
    "password_again_text": "Inserisci di nuovo la password",
    "pid_text": "Codice di invito",
    "pid_pl": "Facoltativo",
    "invitation_code_no_data": "Il codice di invito è obbligatorio",
    "xy": "Accordo utente",
    "xy_no_checked": "Seleziona l'accordo",
    "agree": "Ho letto e accetto",
    "register_btn": "Registrati",
    "bz": [
      "Le informazioni sulla nazionalità non possono essere modificate dopo la registrazione, assicurati di scegliere correttamente.",
      "L'email di verifica potrebbe essere classificata come spam, controlla attentamente.",
      "Conserva il tuo account " + window.GLOBAL.LANG_TITLE.zh + " e la password di accesso con cura.",
      "Non utilizzare la stessa password di accesso su altri siti."
    ],
    "account_no_data": "L'account non può essere vuoto",
    "code_no_equality": "I codici di verifica non corrispondono",
    "password_no_data": "La password non può essere vuota",
    "password_no_equality": "Le due password non corrispondono"
  },
  "bindmpwd": {
    "title": "Imposta password",
    "account": "Account",
    "code_text": "Inserisci il codice di verifica",
    "code_btn": "Ottieni codice di verifica",
    "code_unit": "s",
    "password_text": "Inserisci la password",
    "password_again_text": "Inserisci di nuovo la password",
    "code_no_data": "Il codice di verifica non può essere vuoto",
    "code_no_equality": "I codici di verifica non corrispondono",
    "password_no_data": "La password non può essere vuota",
    "password_no_equality": "Le due password non corrispondono",
    "bindmpwd_btn": "Conferma",
    "phone_no_data": "Il numero di telefono non può essere vuoto",
    "password_login_text": "Inserisci la password di accesso",
    "password_trade_text": "La password deve avere una lunghezza di 6 cifre",
    "password_again_tarde_text": "La password deve avere una lunghezza di 6 cifre"
  },
  "forgetpwd": {
    "title": ["Modifica password", "Password dimenticata"],
    "account": "Account",
    "code_text": "Inserisci il codice di verifica",
    "code_btn": "Ottieni codice di verifica",
    "code_unit": "s",
    "password_text": "Inserisci la password",
    "password_again_text": "Inserisci di nuovo la password",
    "phone_no_data": "Il numero di telefono non può essere vuoto",
    "account_no_data": "L'account non può essere vuoto",
    "code_no_data": "Il codice di verifica non può essere vuoto",
    "code_no_equality": "I codici di verifica non corrispondono",
    "password_no_data": "La password non può essere vuota",
    "password_no_equality": "Le due password non corrispondono",
    "forgetpwd_btn": "Conferma"
  },
  "bindphone": {
    "title": "Collega numero di telefono",
    "phone_text": "Numero di telefono"
  },
  "person": {
    "more": "Carica di più",
    "no_more": "Nessun dato disponibile",
    "index_center": "Centro utenti",
    "index_menus": [
      {
        "icon": "zhsz",
        "title": "Gestione account",
        "path": "/setting"
      },
      {
        "icon": "sfrz",
        "title": "Verifica identità",
        "path": "/sfyz"
      },
      {
        "icon": "sfrz",
        "title": "Verifica di base",
        "path": "/smauth"
      },
      {
        "icon": "jtrz",
        "title": "Verifica avanzata",
        "path": "/seniorauth"
      },
      {
        "icon": "jtrz",
        "title": "Verifica indirizzo",
        "path": "/dzrz"
      },
      {
        "icon": "jtrz",
        "title": "Acquisto rapido di criptovalute",
        "path": "/kjmbSelect"
      },
      {
        "icon": "jtrz",
        "title": "Punti di credito",
        "path": "/credit"
      },
      {
        "icon": "jtrz",
        "title": "Registro account",
        "path": "/deallog"
      },
      {
        "icon": "jtrz",
        "title": "Registro ricariche",
        "path": "/cbjl"
      },
      {
        "icon": "jtrz",
        "title": "Registro prelievi",
        "path": "/tbjl"
      }
    ],
    "cbtb": "Ricarica e prelievo",
    "jymx": "Dettagli transazione",
    "xyf": {
      "title": "Punti di credito",
      "pgsj": "Tempo di valutazione"
    },
    "smrz": {
      "title": "Verifica dell'identità",
      "sure_title": "Hai superato la verifica dell'identità",
      "zj_type": "Tipo di documento",
      "zj_info": [
        "1. Le informazioni di verifica non possono essere modificate una volta verificate, assicurati di compilare correttamente.",
        "2. Le informazioni verificate non possono essere verificate di nuovo."
      ],
      "zj_name": "Nome",
      "zj_num": "Numero di documento",
      "zj_btn": "Conferma",
      "zj_rebtn": "Verifica di nuovo",
      "zj_sebtn": "Verifica avanzata",
      "zj_type_array": [
        {
          "name": "Carta d'identità",
          "type": "idcard"
        }
      ],
      "idCardArr": [
        {
          "id": 1,
          "name": "Carta d'identità"
        },
        {
          "id": 2,
          "name": "Passaporto"
        },
        {
          "id": 3,
          "name": "Patente di guida"
        },
        {
          "id": 4,
          "name": "Permesso di soggiorno"
        },
        {
          "id": 5,
          "name": "Altro"
        }
      ],
      "zj_data": {
        "city": "La nazionalità non può essere vuota",
        "type": "Il tipo di documento non può essere vuoto",
        "name": "Il nome non può essere vuoto",
        "zj_num": "Il numero di documento non può essere vuoto"
      },
      "zsxm": "Nome reale",
      "qsrzsxm": "Inserisci il nome reale",
      "zjlx": "Tipo di documento",
      "qxzzjlx": "Seleziona il tipo di documento",
      "sfz": "Carta d'identità",
      "zjhm": "Numero di documento",
      "qsrzjhm": "Inserisci il numero di documento",
      "sczjz": "Carica foto del documento",
      "zjzm": "Carica foto frontale del documento",
      "zjfm": "Carica foto posteriore del documento",
      "qsczjzm": "Carica foto frontale del documento",
      "qsczjfm": "Carica foto posteriore del documento",
      "scqmz": "Carica foto del documento con la firma personale",
      "qscscqmz": "Carica foto del documento con la firma personale",
      "zj": [
        {
          "id": 1,
          "title": "Carta d'identità"
        },
        {
          "id": 2,
          "title": "Passaporto"
        },
        {
          "id": 3,
          "title": "Altro"
        }
      ],
      "tj": "Invia",
      "shz": "In fase di revisione",
      "shtg": "Revisione approvata"
    },
    "gjrz": {
      "title": "Verifica avanzata",
      "zj_info": [
        "1. Supporta immagini in formato JPG, JPEG o PNG di dimensioni inferiori a 8M.",
        "2. Le foto del documento devono essere chiare, non consentite modifiche o coperture, devono mostrare chiaramente il volto, il numero del documento e il nome.",
        "3. Le foto devono essere senza cappello, si consiglia di non truccarsi, il viso deve essere chiaramente visibile, con le braccia completamente visibili."
      ],
      "zj_img": [
        "/static/image/User_Center_Front_view.png",
        "/static/image/User_Center_Back_Shot.png",
        "/static/image/User_Center_Full_picture.png"
      ]
    },
    "zhgl": {
      "title": "Impostazioni di sicurezza",
      "bind": [
        {
          "bind_title": "Reimposta password",
          "bind_name": "Email"
        },
        {
          "bind_title": "Imposta password di trading",
          "bind_name": "Email"
        }
      ]
    },
    "wdtg": {
      "own_code": "Codice di invito esclusivo",
      "own_code_url": "Collegamento di invito esclusivo",
      "own_push_title": "Le mie promozioni",
      "own_push_content": [
        "Entrate totali da inviti (valutazione)",
        "Numero di invitati",
        "persone"
      ],
      "own_push_content_profit": [
        "Entrate da inviti di primo livello",
        "Entrate da inviti di secondo livello",
        "Entrate da inviti di terzo livello",
        "Entrate da inviti di quarto livello"
      ],
      "own_push_content_num": [
        "Numero di invitati di primo livello",
        "Numero di invitati di secondo livello",
        "Numero di invitati di terzo livello",
        "Numero di invitati di quarto livello"
      ],
      "own_push_profit_title": [
        "ID",
        "Entrate",
        "Informazioni aggiuntive",
        "Data di aggiunta"
      ],
      "own_push_num_title": [
        "ID",
        "Nome",
        "Telefono",
        "Data di aggiunta"
      ]
    },
    "jyzt_td": ["Tempo", "Dettagli", "Importo"],
    "cbjl_td": ["Tempo", "Valuta", "Quantità", "Stato"],
    "sfrz_txt": [
      "Verifica identità",
      "Hai inviato la richiesta di revisione, attendi il risultato",
      "Hai superato la verifica avanzata",
      "Fronte della carta d'identità",
      "Retro della carta d'identità",
      "Verifica",
      "Verifica fallita, ripeti la verifica"
    ],
    "zhsz_txt": [
      "Il tuo livello di sicurezza dell'account: #",
      "Il tuo livello di sicurezza dell'account: #, completa ulteriori informazioni per garantire la sicurezza dell'account"
    ],
    "zhsz_m": "Forte",
    "zhsz_n": "Debole",
    "zhsz_p": "Non sicuro",
    "zhsz_detailList": [
      {
        "icon": "iconchecked",
        "title": "Il mio codice di invito",
        "value": "",
        "btn": "Copia codice di invito",
        "class": "copy",
        "event": "copy"
      },
      {
        "icon": "/static/image/User_Center-email.png",
        "title": "Email",
        "value": "Utilizzata per accesso, prelievi, impostazioni di sicurezza",
        "value2": "",
        "btn": "Collega",
        "btn2": "Già collegata",
        "path2": "/bindphone"
      },
      {
        "icon": "/static/image/User_Center-phone.png",
        "title": "Telefono",
        "value": "Utilizzato per prelievi, modifica password, ricezione SMS di verifica",
        "value2": "",
        "btn": "Collega",
        "btn2": "Già collegato",
        "path2": "/bindphone"
      },
      {
        "icon": "/static/image/User_Center-password.png",
        "title": "Password di accesso",
        "value": "Gli account Internet sono a rischio di furto, si consiglia di cambiare regolarmente la password per proteggere la sicurezza dell'account.",
        "value2": "",
        "btn": "Modifica",
        "bind_email": "Collega prima l'email o il telefono",
        "path": "/forgetpwd?type=changepwd"
      },
      {
        "icon": "/static/image/User_Center-password.png",
        "title": "Password di trading",
        "value": "Imposta la password",
        "btn": "Vai a impostare",
        "path": "/bindmpwd"
      }
    ],
    "sksz_txt": ["Impostazioni di ricezione", "Salva"],
    "sksz_list": [
      {
        "label": "Nome utente:",
        "pl": "Inserisci il nome utente",
        "key": "name"
      },
      {
        "label": "Nome della banca:",
        "pl": "Inserisci il nome della banca",
        "key": "bank_name"
      },
      {
        "label": "Numero di conto bancario:",
        "pl": "Inserisci il numero di conto bancario",
        "key": "bank_number"
      },
      {
        "label": "Numero di conto Alipay:",
        "pl": "Inserisci il numero di conto Alipay",
        "key": "alipay_account"
      },
      {
        "label": "Nickname WeChat:",
        "pl": "Inserisci il nickname WeChat",
        "key": "weixin_nickname"
      },
      {
        "label": "Account WeChat:",
        "pl": "Inserisci l'account WeChat",
        "key": "weixin_account"
      }
    ]
  },
  "pasination": {
    "first": "Home",
    "prev": "Pagina precedente",
    "next": "Pagina successiva",
    "last": "Ultima pagina",
    "no_data": "Nessun dato disponibile"
  },
  "asset": {
    "title": "I miei asset",
    "zjhz": "Trasferimento di fondi",
    "cb": "Ricarica",
    "gz": "Valutazione USDT",
    "atnv": [],
    "zh_title": "Totale asset equivalenti:",
    "index_title": "Asset",
    "address_title": "Tipo di valuta",
    "address_txt": ["Seleziona", "Indirizzo di prelievo", "Inserisci contenuto", "Nota", "Lista indirizzi"],
    "address_btn": ["Aggiungi", "Salva", "Elimina", "Modifica"],
    "address_td": ["Tipo di valuta", "Indirizzo di prelievo", "Nota", "Operazioni"],
    "currency_td": ["Tipo di valuta", "Disponibile", "Bloccato", "Equivalente"],

    "table_title": "Totale asset:",
    "table_address_title": "Gestione indirizzi di prelievo",
    "table_td": ["Tipo di valuta", "Disponibile", "Bloccato", "Equivalente", "Operazioni"],
    "table_btn": ["Ricarica", "Prelievo", "Registro", "Trasferimento"],

    "money_text": ["Indirizzo di prelievo", "Seleziona", "Quantità", "Disponibile:", "Commissione",
      "Quantità accreditata", "Password di trading", "Etichetta (Memo)", "Minimo prelievo"
    ],
    "money_btn": "Prelievo",
    "xzbz": "Seleziona tipo di valuta",
    "money_msg": ["Avviso", "1. Gli orari di prelievo sono dalle 12:00 alle 24:00 ora di Hong Kong, è possibile inviare 2 richieste di prelievo al giorno (minimo prelievo 100u, massimo 200000u);", "2. Attualmente, i prelievi supportano solo la valuta USDT, selezionare il tipo di collegamento del portafoglio ERC20;",
      "3. Dopo aver inviato la richiesta di prelievo, i fondi sono in stato di blocco poiché il prelievo è in corso, i fondi sono temporaneamente gestiti dal sistema e non possono essere utilizzati liberamente. Questo non significa che tu abbia perso questi asset o che ci siano anomalie. Ti preghiamo di attendere l'approvazione;",
      "4. Dopo aver inviato la richiesta di prelievo, il tempo di accredito è basato sul tempo di conferma della blockchain, se non ricevi i fondi dopo il tempo previsto per il prelievo, contatta il servizio clienti per assistenza;", "5. Per prevenire comportamenti di arbitraggio, è necessario accumulare il 90% dell'importo totale speso per iniziare un prelievo."
    ],
    "recharge_title": "Indirizzo di ricarica",
    "recharge_btn": ["Copia", "Codice QR", "Ricarica"],
    "recharge_text": ["Quantità", "Avviso", "Non inviare alcun asset non USDT all'indirizzo sopra, altrimenti gli asset non saranno recuperabili.",
      "Le ricariche USDT supportano solo il metodo 'simple send', l'utilizzo di altri metodi (send all) non accreditati temporaneamente, ti preghiamo di comprendere.", "Ricevuta", "Descrizione della ricevuta (facoltativo)", "Nome della rete"
    ],
    "record_title": "Registro finanziario",
    "record_td": ["Quantità", "Registro", "Tempo"],
    "transfer_title": "Trasferimento",
    "transfer_btn": ["Tutto", "Trasferisci"],
    "transfer_text": ["Da", "A", "Inserisci la quantità da trasferire", "Disponibile:"],
    "bq": "Etichetta (Memo)",
    "qsrbq": "Inserisci etichetta",
    "yhktx": "Prelievo su conto bancario",
    "yhmc": "Nome della banca",
    "qsryhmc": "Inserisci il nome della banca",
    "yhzh": "Numero di conto bancario",
    "qsryhzh": "Inserisci il numero di conto bancario",
    "gjhkdm": "Codice di trasferimento internazionale",
    "qsrgjhkdm": "Inserisci il codice di trasferimento internazionale",
    "yhdz": "Indirizzo della banca",
    "qsryhdz": "Inserisci l'indirizzo della banca",
    "skrxm": "Nome del beneficiario",
    "qsrskrxm": "Inserisci il nome del beneficiario",
    "skrdh": "Telefono del beneficiario",
    "qsrskrdh": "Inserisci il telefono del beneficiario",
    "skrdz": "Indirizzo del beneficiario",
    "qsrskrdz": "Inserisci l'indirizzo del beneficiario"
  },
  "text": {
    "btn": "Torna",
    "login": "Accedi prima"
  },
  "deal": {
    "chooseType": "Tipo di ordine",
    "choose": "Seleziona",
    "balance": "Saldo:",
    "account": ["Account", "Disponibile", "/Bloccato", "Trasferimento"],
    "dir": ["Acquista", "Vendi"],
    "dir2": ["Acquistabile", "Vendibile"],
    "cs": "Preferiti",
    "sxf": "Commissione",
    "jye": "Importo della transazione",
    "sc_list": ["Mercato", "Nome", "Variazione"],
    "sc_h": ["Prezzo attuale", "Prezzo minimo 24H", "Prezzo massimo 24H", "Volume 24H"],
    "td_lt": ["Tipo di valuta", "Prezzo attuale", "Variazione"],
    "k_line_txt": ["≈", "", "Variazione", "Prezzo massimo", "Prezzo minimo", "Volume 24H"],
    "tabListLTitle": ["Ordini attuali", "Ordini storici"],
    "tabListLEntrust": ["Acquista", "Vendi"],
    "tabListRTitle": ["Trading a limite", "Trading a mercato"],
    "table_btn": ["Annulla ordine"],
    "index_td_l": ["Tempo", "Oggetto della transazione", "Quantità", "Prezzo", "Operazioni"],
    "index_td_r": ["Prezzo attuale", "Direzione", "Prezzo", "Quantità"],
    "index_td_r2": ["Ultima transazione", "Tempo", "Prezzo", "Volume"],
    "table_txt": ["Completato", "Annullato"],
    "db_1_txt": ["Disponibile", "Prezzo di acquisto", "Prezzo di vendita", "Quantità di acquisto", "Quantità di vendita", "Importo della transazione", "Acquista al miglior prezzo di mercato", "Vendi al miglior prezzo di mercato", "Mani di acquisto", "Mani di vendita"],
    "db_2_txt": ["Prezzo", "Leva", "Seleziona", "Mani", "Una mano = ", "Mani", "Valore di mercato del contratto", "Margine", "Acquista al miglior prezzo di mercato", "Vendi al miglior prezzo di mercato"],
    "pathList": ["Registro contratti", "Registro transazioni"],
    "db_btn": ["Acquista (Long)", "Vendi (Short)"],
    "tabListLTitle2": ["Ordini attuali"],
    "lt_btn": ["Chiusura con un clic", "Imposta prezzo di take profit e stop loss", "Chiudi posizione", "Invia immediatamente", "Torna"],
    "lt_txt": ["Tasso di rischio:", "Guadagno/perdita totale della posizione:"],
    "lt_td": ["Tipo", "Leva", "Prezzo di apertura", "Prezzo attuale", "Margine", "Prezzo di take profit", "Prezzo di stop loss", "Tempo di apertura", "Mani", "Guadagno/perdita", "Operazioni"],
    "lt_dl": ["Imposta prezzo di take profit e stop loss", "Prezzo di take profit", "Prezzo di stop loss"],
    "lt_0_btn": ["Annulla ordine"],
    "lt_0_td": ["Contatto", "Tipo di valuta", "Quantità", "Prezzo attuale", "Commissione", "Operazioni"],
    "lt_1_btn": ["Chiudi posizione"],
    "lt_1_txt": ["Chiusura in corso"],
    "lt_1_td": ["Tipo", "Prezzo di apertura", "Prezzo attuale", "Margine", "Prezzo di take profit", "Prezzo di stop loss", "Tempo di apertura", "Commissione", "Guadagno/perdita", "Operazioni"],
    "node_data": "Nessun dato disponibile",
    "lt_3_txt": ["Posizione chiusa", "Posizione liquidata"],
    "lt_3_td": ["Tipo", "Mani", "Prezzo di apertura", "Prezzo di chiusura", "Prezzo di take profit", "Prezzo di stop loss", "Margine", "Margine disponibile", "Tempo di apertura", "Tempo di chiusura", "Commissione",
      "Guadagno/perdita", "Operazioni"
    ],
    "lt_4_txt": ["Ordine annullato"],
    "cm": ["Data di emissione", "Quantità totale emessa", "Quantità in circolazione", "Prezzo totale", "Sito ufficiale", "Whitepaper", "Introduzione"],
    "qsrsl": "Inserisci la quantità",
    "qsrss": "Inserisci il numero di mani"
  },
  "notice": {
    "notice_title": "Centro notifiche"
  },
  "bzhl": {
    "title": "Rimborso della posizione",
    "ttzbt": "Guadagni quotidiani",
    "wdtg": "La mia gestione",
    "zztgdzj": "Fondi in gestione",
    "yjjrsy": "Guadagno giornaliero stimato",
    "ljsy": "Guadagno totale",
    "tgzdd": "Ordini in gestione",
    "tgdd": "Ordini di gestione",
    "t1": "Investimenti a basso rischio e stabili, riscattabili in qualsiasi momento",
    "t2": "Il tuo assistente per la gestione dei fondi",
    "cljxcp": "Ciclo del prodotto",
    "dbxe": "Limite per transazione",
    "rsyl": "Tasso di rendimento (%)",
    "rsyl2": "Tasso di rendimento giornaliero:",
    "zq": "Ciclo",
    "qmr": "Acquista ora",
    "ckgd": "Visualizza di più",
    "cpgk": "Panoramica del prodotto",
    "pxsj": "Tempo di distribuzione",
    "tgzj": "Fondi in gestione",
    "tqsh": "Riscatto",
    "cpld": "Punti salienti del prodotto",
    "cpgz": "Regole del prodotto",
    "cont": "Il trading è effettuato tramite la gestione dei fondi USDT sulla piattaforma, con un team professionale che gestisce i diritti di trading, i partecipanti possono guadagnare una quota dei profitti durante la gestione dei fondi, con accesso sicuro e comodo.",
    "zj": "100% dei fondi",
    "aqbz": "Garanzia di sicurezza",
    "jjrsy": "Guadagni durante le festività",
    "bjd": "Continuo",
    "cgcrh": "Dopo il deposito riuscito",
    "dtqx": "Interessi a partire da oggi",
    "ljzr": "Trasferisci immediatamente",
    "xqglgj": "Strumento di gestione dei fondi",
    "ddh": "Numero d'ordine",
    "tgje": "Importo in gestione",
    "tgsj": "Numero di giorni del ciclo",
    "yhl": "Guadagnato/Rimanenti giorni",
    "xdsj": "Tempo di ordine",
    "zt": "Stato",
    "fh": "Torna",
    "qrnhsy": "Guadagno annualizzato su sette giorni",
    "ygy": "1 mese",
    "bn": "6 mesi",
    "yn": "1 anno",
    "yuan": "Yuan",
    "tzfx": "Rischio di investimento",
    "shsc": "Durata del riscatto",
    "di": "Basso",
    "yggzr": "Un giorno lavorativo",
    "msgsxf": "Nessuna commissione di acquisto",
    "mr": "Giornaliero",
    "dqfh": "Restituzione alla scadenza",
    "ljgm": "Acquista subito",
    "tgz": "In gestione",
    "sh": "Riscatto",
    "ywc": "Completato",
    "ysh": "Riscattato",
    "all": "Tutti",
    "xzbzts": "Semplice, sicuro. Puoi scegliere tra diverse valute per la distribuzione dei guadagni.",
    "qtbz": "Altre valute"
  },
  "pay": {
    "qsrjymm": "Inserisci la password di transazione di 6 cifre",
    "tbmmts": "Imposta la password di transazione nel centro utenti"
  },
  "tips": {
    "qxztbdz": "Inserisci l'indirizzo di prelievo",
    "qsrtbsl": "Inserisci la quantità di prelievo"
  },
  "statusText": ["Fallito", "In attesa di elaborazione", "Successo"],
  "dzrz": {
    "title": "Verifica indirizzo",
    "sdddz": "Indirizzo della bolletta",
    "zdtpsc": "Caricamento immagine della bolletta",
    "qsrsdddz": "Devi compilare le informazioni sull'indirizzo e caricare la bolletta della bolletta o della connessione internet",
    "qsczdtp": "Carica l'immagine della bolletta",
    "status": ["In revisione", "Revisione approvata"],
    "qd": "Conferma"
  },
  "jgcc": {
    "wtgd": "Ordine di commissione",
    "cj": "Completato",
    "jj": "Introduzione",
    "zc": "In possesso",
    "lszc": "Storico delle posizioni",
    "qblx": "Tutti i tipi",
    "xj": "Prezzo attuale",
    "sj": "Tempo",
    "fx": "Direzione",
    "jg": "Prezzo",
    "sl": "Quantità",
    "jgsj": "Tempo di consegna",
    "gmj": "Prezzo di acquisto",
    "jsj": "Prezzo di regolazione",
    "yk": "Guadagno/perdita",
    "xq": "Dettagli",
    "mz": "Acquista in aumento",
    "md": "Acquista in diminuzione",
    "dqye": "Saldo attuale",
    "gb": "Chiudi",
    "jxxd": "Continua a ordinare",
    "qrxd": "Conferma ordine",
    "ddqr": "Conferma ordine",
    "sxf": "Commissione",
    "kyye": "Saldo disponibile",
    "jypz": "Nome",
    "jyfx": "Direzione della transazione",
    "tzje": "Importo dell'investimento",
    "tzjeTips": "L'importo dell'investimento non può essere 0",
    "dqsj": "Tempo di scadenza",
    "jssj": "Tempo di regolazione",
    "gmsj": "Tempo di acquisto",
    "sy": "Guadagni",
    "zxje": "Quantità minima",
    "shi": "Ore",
    "fen": "Minuti",
    "miao": "Secondi",
    "zdje": "Quantità massima",
    "qsrje": "Inserisci l'importo",
    "zxtzje": "Quantità minima",
    "yebz": "Saldo insufficiente",
    "xq": "Dettagli",
    "ddz": "In attesa",
    "jgjl": "Registro di consegna",
    "bz": "Tipo di valuta",
    "cz": "Operazioni"
  },
  "kjmb": {
    "title": "Acquisto rapido di criptovalute",
    "fzcg": "Copia riuscita",
    "ljmb": "Acquista subito criptovalute",
    "lxkf": "Contatta il servizio clienti"
  },
  "news": {
    "title": "I miei messaggi",
    "gg": "Annuncio",
    "ckxq": "Visualizza dettagli"
  },
  "statusTabs": ["Ordini in attesa", "Transazioni in corso", "Posizioni chiuse", "Ordini annullati"],
  "chongzhi": {
    "zy": "Attenzione",
    "tips2": "1. Compatibilità del portafoglio/piano: ovvero supporto per questa rete; se la piattaforma di destinazione non supporta la tua rete di prelievo, gli asset non saranno recuperabili.",
    "tips3": "2. La rete di ricarica e la piattaforma di destinazione devono essere coerenti; se scegli un indirizzo di destinazione su Ethereum ma ricarichi tramite la rete TRC20, potresti non recuperare i tuoi asset digitali.",
    "tips4": "3. Assicurati che il tuo indirizzo e l'importo siano corretti prima della ricarica.",
    "tips5": "Avviso: a causa dell'anonimato e della riservatezza della rete blockchain, se inserisci informazioni errate, perderai gli asset corrispondenti. Assicurati di controllare attentamente il tuo indirizzo e la quantità di ricarica.",
    "cbxx": "Informazioni sulla ricarica",
    "qsrsl": "Inserisci la quantità di ricarica",
    "tips2_1": "• Non inviare alcun asset non appartenente a questa valuta all'indirizzo sopra, altrimenti gli asset non saranno recuperabili.",
    "tips2_2": "• Le criptovalute potrebbero non accreditarsi immediatamente, il tempo di accredito effettivo dipende dalla velocità di conferma della blockchain.",
    "tips2_3": "• Il tuo indirizzo di ricarica non cambierà frequentemente e può essere utilizzato per ricariche ripetute; se ci sono modifiche, faremo del nostro meglio per informarti tramite annunci sul sito o email."
  },
  "tibi": {
    "tbxx": "Informazioni sul prelievo",
    "qsrbq": "Inserisci etichetta",
    "tbTips1": "• Per garantire la sicurezza dei fondi, se la strategia di sicurezza dell'account cambia o viene modificata la password, effettueremo una revisione manuale del prelievo. Ti preghiamo di attendere la chiamata o l'email del nostro personale.",
    "tbTips2": "• Assicurati di confermare che il computer e il browser siano sicuri, per prevenire modifiche o perdite di informazioni.",
    "tbTips3": "• Gli asset digitali che prelevi sono asset multi-chain, indipendentemente dalla catena da cui scegli di prelevare, significa che la quantità totale di asset digitali visualizzati nella pagina di prelievo diminuirà di conseguenza."
  },
  "gjlb": "Elenco dei paesi",
  "qxzgjlb": "Seleziona paese/regione",
  "mbwt": {
    "title": "Impostazione delle domande di sicurezza",
    "mbwt": "Domande di sicurezza",
    "problem": [{
        "id": 1,
        "title": "Chi era il tuo migliore amico da bambino?"
      },
      {
        "id": 2,
        "title": "Chi è il tuo idolo?"
      },
      {
        "id": 3,
        "title": "Qual è il luogo che desideri di più?"
      }
    ],
    "qtxda": "Inserisci la risposta",
    "qsrxmm": "Inserisci la nuova password",
    "qqrmm": "Conferma la password",
    "sydqmmcz": "Reimposta utilizzando la password attuale",
    "zhmm": "Recupero della password tramite domanda di sicurezza",
    "ysz": "Già impostato",
    "tg": "Salta",
    "tj": "Invia",
    "zyts": "Avviso importante:",
    "zytsCont": "Non divulgare le risposte alle domande di sicurezza e i codici di verifica, e ricorda le domande di sicurezza, questo ti aiuterà a recuperare la password."
  },
  "zc": {
    "zclb": "Elenco degli asset",
    "zczh": "Equivalente degli asset",
    "yczc": "Nascondi asset pari a 0"
  },
  "indexNew": {
    "t1": "Piattaforma di servizi per asset digitali leader a livello mondiale",
    "t2": "Completamente integrata per il trading di asset digitali su blockchain",
    "t3": "Numero di telefono/email",
    "t4": "Registrati ora",
    "t5": "Benvenuti clienti da tutto il mondo attraverso GMO Global",
    "t6": "Scopri e inizia il tuo viaggio nel mondo delle criptovalute"
  },
  "newReg": {
    "dl": ["Email", "Telefono"],
    "cjzh": "Crea account",
    "sysjhzyx": "Registrati utilizzando il numero di telefono/email",
    "yhxy": "《Accordo utente》",
    "yhxy2": "Ho letto e accetto l'《Accordo utente》",
    "yxgz": "L'email inserita non è valida",
    "dhgz": "Il formato del numero di telefono inserito è errato"
  },
  "indexNew2": {
    "t1": "Scambia sui nostri ordini",
    "t2": "Utilizza Bitbank",
    "t3": "Bitbank è uno scambio di Bitcoin e asset crittografici progettato in modo intelligente, molto semplice, conveniente, sicuro e potente. Supporta il trading su più piattaforme web e smartphone. I dati e i grafici di trading vengono aggiornati in tempo reale, offrendo oltre 60 strumenti di analisi tecnica per un'analisi completa dei prezzi di mercato. Inizia a fare trading",
    "ksjy": "Inizia a fare trading",
    "ly": "5 motivi per scegliere Bitbank",
    "item1_t1": "Volume di trading leader",
    "item1_t2": "No.1 * volume di trading di asset crittografici",
    "item1_t3": "Alta liquidità, esperienza di trading confortevole (piacevole). 12 asset crittografici elencati.",
    "item2_t1": "Alte valutazioni da terzi",
    "item2_t2": "Ambiente di trading sicuro",
    "item2_t3": "Utilizza portafogli freddi offline. Rifiuta gli hacker tramite Multisig. Proteggi i tuoi asset con alta tecnologia.",
    "item3_t1": "Applicazione facile da usare e affidabile",
    "item3_t2": "Applicazione facile e semplice da usare",
    "item3_t3": "Applicazione affidabile con funzionalità ricche. Può mantenere opportunità di trading anche all'esterno.",
    "item4_t1": "Disponibile 24 ore su 24",
    "item4_t2": "Depositi disponibili",
    "item4_t3": "Supporto per depositi 24 ore su 24, anche durante le festività!",
    "item5_t1": "Smartphone e PC",
    "item5_t2": "Design user-friendly",
    "item5_t3": "Anche utilizzando uno smartphone, puoi eseguire operazioni semplici senza esitazione.",
    "aqkk": "Sicuro e affidabile",
    "aqkk2": "Trading di Bitcoin su Bitbank",
    "cjzh": "Crea un account"
  },
  "xbsg": {
    "title": "Richiesta di nuovi asset",
    "wdsg": "Le mie richieste",
    "scts": "Giorni di blocco:",
    "sy": "Rimanente",
    "ljsg": "Richiesta immediata",
    "ysk": "Esaurito",
    "xzjdy": "Iscriviti ora",
    "dy": "Iscrizione",
    "fxjg": "Prezzo di emissione",
    "fxl": "Quantità di emissione",
    "ssrq": "Data di quotazione",
    "yxqx": "Scadenza",
    "qsrsl": "Inserisci la quantità",
    "syl": "Quantità rimanente",
    "sgrq": "Data di richiesta",
    "sgsl": "Quantità richiesta",
    "bz": "Tipo di valuta",
    "yebz": "Saldo USDT insufficiente",
    "tgsl": "Quantità di passaggio",
    "shz": "In revisione",
    "wtg": "Non approvato",
    "ytg": "Approvato"
  },
  "wydb": {
    "title": "Voglio prestiti",
    "db": "Prestiti",
    "dbz": "In prestito",
    "jl": "Registro",
    "jdzq": "Periodo di prestito (giorni)",
    "qhk": "Rimborso",
    "ljdb": "Prestito totale (USDT)",
    "dhkbs": "Numero di prestiti in attesa",
    "jkje": "Importo del prestito (USDT)",
    "qsrje": "Inserisci l'importo",
    "rll": "Tasso di interesse giornaliero",
    "hkfs": "Metodo di rimborso",
    "dqych": "Rimborso in un'unica soluzione alla scadenza",
    "lx": "Interessi",
    "fkjg": "Istituto di prestito",
    "tpsc": "Prestito personale (caricamento immagini)",
    "fwxx": "Informazioni sulla proprietà",
    "srzm": "Prova di reddito (rapporto di lavoro)",
    "yhmx": "Dettagli bancari",
    "zjz": "Foto del documento",
    "yd": "Ho letto e accetto",
    "xy": "Accordo di prestito",
    "sqdb": "Clicca per richiedere un prestito",
    "gb": "Chiudi",
    "qd": "Conferma",
    "ts": "Seleziona l'accordo di prestito",
    "dbjl": "Registro prestiti",
    "hkhth": "Numero di contratto di prestito",
    "wsh": "Non revisato",
    "yfk": "Prestato",
    "sqrq": "Data di richiesta",
    "zq": "Periodo",
    "dbsl": "Quantità di prestito",
    "zhke": "Importo totale da rimborsare",
    "yhkxq": "Dettagli del rimborso",
    "bqyhk": "Importo da rimborsare (USDT)",
    "hktips": "Assicurati che il saldo sia sufficiente, se il saldo è insufficiente, ricarica prima di rimborsare.",
    "bj": "Capitale",
    "jie": "Prestare",
    "ljhk": "Rimborso immediato",
    "qcz": "Ricarica",
    "yebzqxcz": "Saldo insufficiente, ricarica prima di rimborsare.",
    "znj": "Penale per ritardo",
    "yqts": "Giorni di ritardo"
  },
  "hkxq": {
    "dd": "Ordine",
    "fzhkdz": "Copia indirizzo di rimborso",
    "hkxq": "Dettagli rimborso",
    "zlx": "Interessi totali",
    "zhk": "Rimborso totale",
    "hkjg": "Istituto di rimborso",
    "qschkpz": "Carica la ricevuta di rimborso",
    "hkpz": "Ricevuta di rimborso"
  },
  "bbjyNew": {
    "jylx": "Tipo di transazione",
    "jyze": "Importo totale della transazione"
  },
  "bind": {
    "title": "Verifica email",
    "ybd": "Già collegata",
    "wbd": "Non collegata",
    "ts": "Per proteggere il tuo account, ti consigliamo di collegare un'email",
    "qsryxdz": "Inserisci l'indirizzo email"
  },
  "tipsNew": {
    "yjj": "Rifiutato",
    "shz": "In fase di riscatto"
  },
  "newIndex2": {
    "zxhy": "Ultime notizie di mercato",
    "jypt": "Piattaforma di trading",
    "dqwz": "Posizione attuale",
    "yzm": "Codice di verifica",
    "qrmm": "Conferma password",
    "djdl": "Clicca per accedere",
    "ghdjy": "Migliore trading",
    "ghdsh": "Migliore vita",
    "about": "Il centro di trading crittografico più innovativo del mondo è qui, dove puoi acquistare, scambiare e guadagnare criptovalute, con centinaia di criptovalute a portata di mano.",
    "index01": "La tua porta d'accesso a Bitcoin e altri settori",
    "index02": "Piattaforma di servizi per asset digitali leader a livello mondiale",
    "index03": "Tutte le transazioni sono gratuite",
    "index04": "Nessun costo di apertura conto, nessuna commissione di mantenimento conto, nessuna commissione di stop loss, nessun deposito, nessun costo di stoccaggio/spedizione.",
    "index05": "Sicurezza affidabile",
    "index06": "Utilizzando l'expertise accumulata da GMG INT sin dalla sua fondazione, stiamo costruendo un sistema robusto e implementando varie misure di sicurezza per proteggere in modo sicuro e affidabile i beni dei clienti.",
    "index07": "Trading fisico e trading con leva disponibili",
    "index08": "Le transazioni di piccole dimensioni possono iniziare da circa 10 dollari, con spread tra i più bassi del settore, e puoi utilizzare il saldo del tuo conto come garanzia per il trading con leva, solo GMG INT può addebitare costi di leva.",
    "index09": "Token progettato per potenziare la comunità GMG INT",
    "index10": "Unus Sed LEO è un token applicativo progettato per assistere gli utenti che cercano di massimizzare i benefici e le funzionalità della piattaforma di trading GMG INT.",
    "index11": "Token progettato per potenziare la comunità GMG INT",
    "index12": "Apri la strada a una vita migliore",
    "index13": "Chiunque può possedere criptovalute. Chiunque può fare trading di criptovalute. Ecco come Bitget ti porta oltre.",
    "index14": "Prodotti innovativi",
    "index15": "Trading con copia con un clic",
    "index16": "Trading senza conversione di token",
    "index17": "Scambio di derivati principali con margine USDC",
    "index18": "Controllo del rischio tramite isolamento di portafogli caldi e freddi",
    "index19": "Valutazione A+ da SSL Labs",
    "index20": "Sicurezza affidabile supportata da Suntwin Technology, Qingsong Cloud Security, HEAP e Armors",
    "index21": "Servizio clienti eccezionale",
    "index22": "Supporto online multilingue 24 ore su 24",
    "index23": "Supporto one-to-one per clienti VIP",
    "index24": "Centro premi della comunità",
    "index25": "Costruito da trader per trader",
    "index26": "Fai trading di vari asset digitali, come Bitcoin, Ethereum, Solana e Dogecoin, con costi di trading contenuti.",
    "index27": "Gli strumenti e le informazioni di cui hai bisogno per acquistare, vendere, scambiare, investire e utilizzare criptovalute",
    "index28": "Sicurezza leader nel settore"
  },
  "langNew": {
    "gdjy": "Trading di ordini",
    "szhb": "Valuta digitale",
    "gjs": "Metalli preziosi",
    "yy": "Petrolio",
    "jy": "Trading",
    "jmhb": "Criptovalute",
    "yxhy": "Contratti perpetui",
    "khh": "Banca di apertura",
    "qsrkhh": "Inserisci la banca di apertura",
    "yhkh": "Numero di conto bancario",
    "qsryhkh": "Inserisci il numero di conto bancario",
    "mnzh":"Conto simulato",
    "cjmnzhcg":"Creazione dell'account simulato completata con successo",
    "tcmnzh":"Esci dalla simulazione del conto",
  }
}



// WEBPACK FOOTER //
// ./src/lang/it.js